<template>
  <div class="items">
    <template v-if="items.length">
      <button
        v-for="(item, index) in items"
        :key="item"
        class="item"
        :class="{ 'is-selected': index === selectedIndex }"
        @click="selectItem(index)"
      >
        {{ item }}
      </button>
    </template>
    <div v-else class="item">No result</div>
  </div>
</template>

<script setup lang="ts">
import type { SuggestionKeyDownProps } from '@tiptap/suggestion'
import { ref, watch } from 'vue'

const props = defineProps<{ items: string[]; command: (_args: unknown) => void }>()
const selectedIndex = ref(0)

watch(
  () => props.items,
  () => (selectedIndex.value = 0)
)

const onKeyDown = (keyProps: SuggestionKeyDownProps) => {
  // console.log('onKeyDown', keyProps.event.key)

  if (keyProps.event.key === 'ArrowDown') {
    selectedIndex.value = (selectedIndex.value + 1) % props.items.length
    return true
  }

  if (keyProps.event.key === 'ArrowUp') {
    selectedIndex.value = (selectedIndex.value + props.items.length - 1) % props.items.length
    return true
  }

  if (keyProps.event.key === 'Enter') {
    selectItem(selectedIndex.value)
    return true
  }

  return false
}

defineExpose({ onKeyDown })

const selectItem = (index: number) => {
  const item = props.items[index]

  if (item) {
    props.command({ name: item })
  }
}
</script>

<style scoped>
.items {
  padding: 0.2rem;
  position: relative;
  border-radius: 0.5rem;
  background: #fff;
  color: rgba(0, 0, 0, 0.8);
  overflow: hidden;
  font-size: 0.9rem;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.05),
    0px 10px 20px rgba(0, 0, 0, 0.1);
}

.item {
  display: block;
  margin: 0;
  width: 100%;
  text-align: left;
  background: transparent;
  border-radius: 0.4rem;
  border: 1px solid transparent;
  padding: 0.2rem 0.4rem;
}
.is-selected {
  border-color: #000;
}
</style>
